import { AddCallerIdsAction, CallerIdState } from '../types';

export const setCallerIds = (state: CallerIdState, value: AddCallerIdsAction): CallerIdState => {
  const itemExist = state.callerIds?.find((item) => item?.id?.toString() === value?.payload?.lineNumber);
  if (state.lastSelectedCallerId === value.payload.number) return state;

  if (itemExist) {
    return {
      ...state,
      callerIds:
        state.callerIds?.map((item) => (item.id?.toString() === value?.payload?.lineNumber ? value.payload : item)) ||
        [],
    };
  }

  return {
    ...state,
    callerIds: [...state.callerIds, value.payload],
  };
};
